import { render, staticRenderFns } from "./mulu.vue?vue&type=template&id=fc157564&scoped=true&"
import script from "./mulu.vue?vue&type=script&lang=ts&"
export * from "./mulu.vue?vue&type=script&lang=ts&"
import style0 from "./mulu.vue?vue&type=style&index=0&id=fc157564&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc157564",
  null
  
)

export default component.exports